import type { PaymentOption } from './Payment';
import type { TicketingReasonCodeString } from './Submittable';

export type OrderStatusString = string;

export enum OrderStatus {
  CAN_MODIFY = 'CAN_MODIFY',
  CANNOT_MODIFY = 'CANNOT_MODIFY',
  UPGRADED = 'UPGRADED',
  NOT_UPGRADED = 'NOT_UPGRADED',
  EXPIRED = 'EXPIRED',
  PENDING = 'PENDING',
  PENDING_WITH_ERROR = 'PENDING_WITH_ERROR',
  CANCELLED = 'CANCELLED',
}

/**
 * `IOrder` should be used only for defining specific type for each app.
 * Use `Order` interface for all common files like `commonRoutes`, `libs`, or `states`
 * Submitted Offers
 */
export interface IOrder<TUpgradeType> {
  id: string;
  upgradeType: TUpgradeType;
  encryptedVariantId: string;
  textKey: string;
  amount: number;
  totalAmount: number;
  quantity: number;
  currencyCode?: string;
  paymentOption: PaymentOption;
  modifyUrl: string;
  status: OrderStatus;
  affiliateCode: string;
  affiliateId: number;
  seatAssignments?: Array<SeatAllocation>;
  seatsToBlock?: Array<string>;
  instantUpgrade: boolean;
  timelineImage?: string;
  totalTax?: number;
  equipment: string;
  reason?: TicketingReasonCodeString;
  passengerSeatAssignments?: PassengerSeatAssignments;
  isTotalAmountCalculatedInBackend?: boolean; // See UseConvertVariantToShoppingCartItemOptions interface.
  unifiedModifyUrl?: string;
  additionalAmounts?: Array<AdditionalAmount>;
}

export interface SeatAllocation {
  seatCode: string;
  firstName: string;
  lastName: string;
}

export interface PassengerSeatAssignments {
  oldCabin?: string;
  newCabin: string;
  passengerSeats: Array<PassengerSeat>;
}

export interface PassengerSeat {
  passengerId: string;
  firstName: string;
  lastName: string;
  oldSeat?: string;
  newSeat: string;
}

export interface AdditionalAmount {
  key: string;
  value: number;
}
